import { Link } from "react-router-dom";

export default function SignedOut() {
  return (
    <div className="app" style={{ display: "grid", placeItems: "center", padding: "1rem" }}>
      <div className="panel empty" style={{ maxWidth: "26rem", width: "100%" }}>
        <i className="fas fa-arrow-right-from-bracket" />
        <h1 style={{ fontSize: "1.25rem", color: "var(--ink)", margin: "0 0 .4rem" }}>You've signed out</h1>
        <p style={{ margin: "0 0 1.2rem" }}>Sign in again to keep working.</p>
        <Link to="/dashboard" className="btn primary">Sign in</Link>
      </div>
    </div>
  );
}
